module.exports = __webpack_public_path__ + "img/laughing-smiley.e475d8c7.png";